/* run.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.2 26.5 26.7" xml:space="preserve">
        <path class="foreground-gl" d="M25.36,3.81h-2v1A3.1,3.1,0,0,1,17.2,4.7V3.81H9.59v1A3.09,3.09,0,0,1,3.41,4.7V3.81H1.69A1.38,1.38,0,0,0,.31,5.18V8.7H26.73V5.18a1.37,1.37,0,0,0-1.37-1.37" transform="translate(-0.31 -0.32)"/>
        <path class="foreground-gl" d="M6.46,6.56a1.9,1.9,0,0,1-1.91-1.9V2.23a1.91,1.91,0,1,1,3.81,0V4.66a1.9,1.9,0,0,1-1.9,1.9" transform="translate(-0.31 -0.32)"/>
        <path class="foreground-gl" d="M20.34,6.56a1.9,1.9,0,0,1-1.91-1.9V2.23a1.91,1.91,0,1,1,3.81,0V4.66a1.9,1.9,0,0,1-1.9,1.9" transform="translate(-0.31 -0.32)"/>
        <path class="foreground-gl" d="M10,13.24V24.16l9.21-5.46ZM1.69,26.82A1.38,1.38,0,0,1,.31,25.44V10.81H26.79V25.44a1.44,1.44,0,0,1-1.44,1.38H1.69" transform="translate(-0.31 -0.32)"/>
        </svg>
    `
};
